import { Component, Input } from '@angular/core';
import { TableCellComponent } from '@captiveaire/table';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';

@Component({
    selector: 'dl-device-status-expand-row',
    templateUrl: './device-status-expand-row.component.html'
})
export class DeviceStatusExpandRowComponent extends TableCellComponent {
    @Input() public item: IDeviceStatusListSummary;
}
